import { render, staticRenderFns } from "./alerts-item.vue?vue&type=template&id=239a68b9&"
import script from "./alerts-item.vue?vue&type=script&lang=js&"
export * from "./alerts-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports